(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.scrollTolerance = 2;
      this.isTicking = false;
    }

    connectedCallback() {
      this.header = this.closest('.section-header');

      if (!this.header) {
        return;
      }

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.currentScrollTop = Math.max(
        0,
        window.pageYOffset ||
          document.documentElement.scrollTop ||
          0
      );

      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.onMediaQueryChange = this.setHeaderHeight.bind(this);
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.mobileMediaQuery.addEventListener(
        'change',
        this.onMediaQueryChange
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.requestScrollUpdate.bind(this);

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        { passive: true }
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      if (this.mobileMediaQuery && this.onMediaQueryChange) {
        this.mobileMediaQuery.removeEventListener(
          'change',
          this.onMediaQueryChange
        );
      }
    }

    setHeaderHeight() {
      if (!this.header) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    requestScrollUpdate() {
      if (this.isTicking) {
        return;
      }

      this.isTicking = true;

      window.requestAnimationFrame(() => {
        this.onScroll();
        this.isTicking = false;
      });
    }

    onScroll() {
      const scrollTop = Math.max(
        0,
        window.pageYOffset ||
          document.documentElement.scrollTop ||
          0
      );

      const scrollDifference =
        scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      /*
        In cima alla pagina l'header torna al suo stato originale.
      */
      if (scrollTop <= this.scrollTolerance) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      /*
        Ignora soltanto movimenti minimi del browser.
        Non viene usata alcuna soglia legata alla Hero o alle card.
      */
      if (Math.abs(scrollDifference) <= this.scrollTolerance) {
        return;
      }

      this.header.classList.add('scrolled-past-header');

      /*
        Scroll verso il basso: nasconde l'header.
        Scroll verso l'alto: mostra immediatamente l'header
        da qualunque punto della pagina.
      */
      if (scrollDifference > 0) {
        if (!this.preventHide) {
          this.hide();
        }
      } else if (!this.preventReveal) {
        this.reveal();
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = window.setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        this.hide();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (
        this.searchModal &&
        typeof this.searchModal.close === 'function'
      ) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
